export default {
  name: "TemplateTooltip",
  props: ["labelContent", "tooltipMess", "labelFor"],
  data() {
    return {
    };
  },
  methods: {
  },
  computed: {

  }
}